import { Route } from '@angular/router';
import { MocIndexPage } from 'app/modules/management-of-change/page/index/index.page';
import { RecordsPage } from 'app/modules/management-of-change/page/records/records.page';
import { ApplicationTrackingPage } from 'app/modules/management-of-change/page/application-tracking/application-tracking.page';
import { MocRecordPage } from 'app/modules/management-of-change/page/moc-record/moc-record.page';
import { MocDashboardPage } from 'app/modules/management-of-change/page/moc-dashboard/moc-dashboard.page';
import { MocFieldSummaryComponent } from 'app/modules/management-of-change/component/field-summary/field-summary.component';
import { MocStringSummaryComponent } from 'app/modules/management-of-change/component/string-summary/string-summary.component';
import { MocApplicationTrackingPage } from 'app/modules/management-of-change/page/moc-application-tracking-record/moc-application-tracking.page';

export const mocDashboardRoutes: Route[] = [
    {
        path: 'moc-dashboard',
        component: MocDashboardPage,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'field',
            },
            {
                path: 'field',
                component: MocFieldSummaryComponent,
            },
            {
                path: 'string',
                component: MocStringSummaryComponent,
            }
        ],
    },
];

export const mocDataManagementRoutes: Route[] = [
    {
        path: 'management-of-change',
        component: MocIndexPage,
        children: [{
            path: '',
            pathMatch: 'full',
            redirectTo: 'records',
        },
        {
            path: 'records',
            component: RecordsPage,
        },
        {
            path: 'application-tracking',
            component: ApplicationTrackingPage,
        },]
    },
    {
        path: 'management-of-change/records/:id/:action',
        component: MocRecordPage
    },
    {
        path: 'management-of-change/application-tracking/:id/:action',
        component: MocApplicationTrackingPage
    },
];

export const mocConfigurationRoutes: Route[] = [
    {
        path: 'management-of-change',
        children: [],
    },
];
